import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice.js";
import issuesSlice from "./slices/issuesSlice.js";
import culpabilitySlice from "./slices/culpability.js";
import appSlice from "./slices/appSlice.js";
import dashboardSlice from "./slices/dashboard.js";
const reducer = {
  auth: authSlice,
  issues: issuesSlice,
  culpability: culpabilitySlice,
  app: appSlice,
  dashboard: dashboardSlice,
};

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export default store;
